import type {
  ApiSchemaClass,
  ApiSchemaDefinition,
  ApiSchemaVersion,
} from './types';
import { instantiateApiSchema } from './types';
import { AGENT_API_SCHEMAS } from './agent';
import { ARTIFACTS_API_SCHEMAS } from './artifacts';
import { ATC_API_SCHEMAS } from './atc';
import { BILLING_API_SCHEMAS } from './billing';
import { CHAT_API_SCHEMAS } from './chat';
import { COCO_API_SCHEMAS } from './coco';
import { CLI_AUTH_API_SCHEMAS } from './cli-auth';
import { COMMITS_API_SCHEMAS } from './commits';
import { DATASET_API_SCHEMAS } from './dataset';
import { DOCUMENT_API_SCHEMAS } from './document';
import { FOLDER_API_SCHEMAS } from './folder';
import { HARNESS_API_SCHEMAS } from './harness';
import { ONBOARDING_API_SCHEMAS } from './onboarding';
import { ORG_API_SCHEMAS } from './org';
import { RESOURCE_API_SCHEMAS } from './resource';
import { SUPER_ADMIN_API_SCHEMAS } from './super-admin';
import { TOOLS_API_SCHEMAS } from './tools';
import { TOOLS_V2_API_SCHEMAS } from './tools-v2';
import { WAREHOUSE_API_SCHEMAS } from './warehouse';
import { WORKFLOW_API_SCHEMAS } from './workflow';

const ALL_API_SCHEMA_CLASSES = [
  ...AGENT_API_SCHEMAS,
  ...ARTIFACTS_API_SCHEMAS,
  ...ATC_API_SCHEMAS,
  ...BILLING_API_SCHEMAS,
  ...CHAT_API_SCHEMAS,
  ...COCO_API_SCHEMAS,
  ...CLI_AUTH_API_SCHEMAS,
  ...COMMITS_API_SCHEMAS,
  ...DATASET_API_SCHEMAS,
  ...DOCUMENT_API_SCHEMAS,
  ...FOLDER_API_SCHEMAS,
  ...HARNESS_API_SCHEMAS,
  ...ONBOARDING_API_SCHEMAS,
  ...ORG_API_SCHEMAS,
  ...RESOURCE_API_SCHEMAS,
  ...SUPER_ADMIN_API_SCHEMAS,
  ...TOOLS_API_SCHEMAS,
  ...TOOLS_V2_API_SCHEMAS,
  ...WAREHOUSE_API_SCHEMAS,
  ...WORKFLOW_API_SCHEMAS,
] as const;

const apiSchemaDefinitionByVersion = new Map<
  ApiSchemaVersion,
  ApiSchemaDefinition
>();

for (const schemaClass of ALL_API_SCHEMA_CLASSES) {
  const definition = instantiateApiSchema(schemaClass);
  apiSchemaDefinitionByVersion.set(definition.name, definition);
}

/** Resolves a registered API schema definition by version name (e.g. `chat-legacy`). */
export const findApiSchemaDefinitionByVersion = (
  version: ApiSchemaVersion
): ApiSchemaDefinition | undefined => apiSchemaDefinitionByVersion.get(version);

/** Every registered definition. The OpenAPI document is built from all of them. */
export const allApiSchemaDefinitions = (): ApiSchemaDefinition[] => [
  ...apiSchemaDefinitionByVersion.values(),
];
